import type { BreadcrumbItem } from "@/components/ui/breadcrumb";

export function paidResourcePageBreadcrumbs(
  pageLabel: string,
  resourceId?: string,
  resourceTitle?: string
): BreadcrumbItem[] {
  const items: BreadcrumbItem[] = [{ label: "Catalog", href: "/catalog" }];
  if (resourceId) {
    items.push({
      label: resourceTitle?.trim() || "Digital resource",
      href: `/catalog/digital/${resourceId}`,
    });
    items.push({ label: pageLabel });
  } else {
    items.push({ label: pageLabel });
  }
  return items;
}
